// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"186":"69887ed3","547":"78e0f8a4","936":"ea6c1751"}[chunkId] + ".css";
};